import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { Button, Stack, Typography } from "@mui/material";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";

type Props = {
  name: string;
  description: string;
  documentationUrl: string;
  documentationLabel: string;
};

export const ExternalDocumentationCard = ({
  name,
  description,
  documentationUrl,
  documentationLabel,
}: Props) => (
  <PrimaryPaper sx={{ mt: 0 }}>
    <Stack gap={2}>
      <Stack gap={0.5}>
        <Typography variant="h6">{name}</Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Stack>
      <Stack direction="row" gap={1} flexWrap="wrap">
        <Button
          component="a"
          href={documentationUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="outlined"
          startIcon={<DescriptionOutlinedIcon />}
        >
          {documentationLabel}
        </Button>
      </Stack>
    </Stack>
  </PrimaryPaper>
);
